module.exports = __webpack_public_path__ + "img/elec.02d132d7.svg";